import { useMemo } from 'react'

import useSiteSettings from '../../../hooks/useSiteSettings'
import { langCodes } from '../../../utils/siteSettings'

const defaultCountryCodeByLang: Record<string, string> = {
  [langCodes.en_US]: 'US',
  [langCodes.en_CA]: 'CA',
  [langCodes.en_AU]: 'AU',
}

export function useDefaultCountryCode(): string {
  const { lang } = useSiteSettings() ?? {}
  return useMemo(() => defaultCountryCodeByLang[lang ?? ''] || 'US', [lang])
}
